import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { batch, connect } from "react-redux";
import querystring from "querystring";
import pick from "lodash/pick";
import { CHECKOUT_CONTEXT_ENUM, setPaymentSessionId, setAppState, setHasEndUserError, updateCart } from "../../store/actions";
import { getPaymentApproved, getPaymentApprovedData, getPaymentCancelled, getPaymentCancelledData } from "../../store/actions/response.actions";
import { APP_STATE } from "../../store/store";
import { Loader } from "../Loader/Loader";
import get from "lodash/get";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
var paybookFactory = function () {
    var Paybook = function (_a) {
        var isApproved = _a.isApproved, setAppState = _a.setAppState, getPaymentCancelled = _a.getPaymentCancelled, getPaymentApproved = _a.getPaymentApproved, hasEndUserError = _a.hasEndUserError, hasErrored = _a.hasErrored, updateCart = _a.updateCart, setHasEndUserError = _a.setHasEndUserError, isLoading = _a.isLoading;
        var search = useLocation().search;
        var queryObject = pick(querystring.parse(search.substr(1)), "payment_session_id", "paymentId", "token", "PayerID");
        var payment_session_id = queryObject.payment_session_id;
        var sendApprovedStatus = {
            approved: function () {
                batch(function () {
                    setAppState(APP_STATE.APPROVED);
                    getPaymentApproved(queryObject);
                    updateCart([]);
                });
            },
            cancelled: function () {
                batch(function () {
                    setAppState(APP_STATE.CANCELLED);
                    getPaymentCancelled(queryObject);
                });
            }
        };
        useEffect(function () {
            setPaymentSessionId(payment_session_id);
            if (isApproved)
                sendApprovedStatus.approved();
            else
                sendApprovedStatus.cancelled();
            return function () {
                setHasEndUserError(false);
            };
        }, [payment_session_id]);
        if (hasErrored)
            return null;
        if (isLoading)
            return React.createElement(Loader, null);
        return null;
    };
    var mapStateToProps = function (state) {
        var _a = getPaymentApprovedData(state.responseReducer).response, approvedResponse = _a === void 0 ? {} : _a;
        var _b = getPaymentCancelledData(state.responseReducer).response, cancelledResponse = _b === void 0 ? {} : _b;
        var loaderState = new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.GET_PAYMENT_APPROVED, API_METHODS_ENUM.GET_PAYMENT_CANCELLED] });
        return {
            isCartContext: get(state, "globalReducer.checkoutContext") === CHECKOUT_CONTEXT_ENUM.CART,
            hasEndUserError: get(approvedResponse, "name") === "end_user_error" || get(cancelledResponse, "name") === "end_user_error",
            hasErrored: loaderState.hasErrored(),
            isLoading: loaderState.isLoading() || !loaderState.hasLoaded()
        };
    };
    return connect(mapStateToProps, { setAppState: setAppState, setPaymentSessionId: setPaymentSessionId, getPaymentCancelled: getPaymentCancelled, getPaymentApproved: getPaymentApproved, updateCart: updateCart, setHasEndUserError: setHasEndUserError })(Paybook);
};
export var PaybookIntermittentPage = paybookFactory();
